module.exports = __webpack_public_path__ + "static/media/FASENRA_R_logo_exUS_RGB_Icon_Left.735117cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FASENRA_R_logo_exUS_RGB_Icon_Left.jpg
// module id = 1373
// module chunks = 0